import { useContext } from 'react';

import { NotificationContext, type NotificationContextType } from '../contexts/NotificationContext';

export function useNotificationContext(): NotificationContextType {
  const context = useContext(NotificationContext);
  if (context === undefined) {
    throw new Error('useNotificationContext must be used within a NotificationProvider');
  }
  return context;
}

// Hook for components that only need to know about connection status
export function useNotificationConnection() {
  const { isConnected, connectionStatus } = useNotificationContext();
  return { isConnected, connectionStatus };
}
